<template>
  <q-card flat>

    <q-card-section>

      <div :class="customerInfoContentClass">
          <div class="row">
            <div class="col-sm-6 col-12 q-px-sm">
              <label for="">First Name *</label>
              <app-editable-input
                :data="value.firstName"
                name="firstName"
                @input="handleChangeInput"
                :error="validation.firstName.$error"
                outlined
                dense
                color="brand6"
              />
            </div>
            <div class="col-sm-6 col-12 q-px-sm">
              <label>Last Name *</label>
              <app-editable-input
                :data="value.lastName"
                textClasses="text-weight-bold"
                name="lastName"
                @input="handleChangeInput"
                :error="validation.lastName.$error"
                outlined
                dense
                color="brand6"
              />
            </div>
            <div class="col-12 col-sm-6 q-px-sm">
              <label>Email *</label>
              <app-editable-input
                :data="value.email"
                type="email"
                name="email"
                @input="handleChangeInput"
                :error="validation.email.$error"
                outlined
                dense
                color="brand6"
              />
            </div>
            <div class="col-sm-6 col-12 q-px-sm">
              <label>Phone *</label>
              <q-input
                v-model="value.phone"
                type="tel"
                name="phone"
                disablePhoneCall
                mask="+1 (###) ### - ####"
                unmasked-value
                :error="validation.phone.$error"
                outlined
                dense
                color="brand6"
              />
            </div>
            <div class="col-sm-6 col-12 q-px-sm">
              <label>Phone 2 (Optional)</label>
              <q-input
                v-model="value.phone2"
                type="tel"
                name="phone2"
                disablePhoneCall
                mask="+1 (###) ### - ####"
                unmasked-value
                outlined
                dense
                color="brand6"
              />
            </div>
            <div class="col-sm-6 col-12 q-px-sm">
              <label>Note (Optional)</label>
              <app-editable-input
                :data="value.note"
                type="textarea"
                name="note"
                @input="handleChangeInput"
                outlined
                dense
                color="brand6"
                :placeholder="noteInfo"
              />
            </div>
          </div>
      </div>
    </q-card-section>
  </q-card>
</template>
<script>
import AppEditableInput from '@client/components/form/editable-input';

const noteInfo = `Please alert us to any information that can effect your transport. Flight date, Moving date, Hours of operation, Gatepass info and passwords etc.
Please also note and modifications to your vehicle. Lifted, Lowered, Oversized tires. Dimensions are also helpful for specialty vehicles.`;

export default {
  name: 'AppBookOrderCustomerInfo',
  components: {
    AppEditableInput
  },
  props: {
    value: Object,
    validation: Object
  },
  data() {
    return {
      valueBackup: null,

      searchingCity: false,
      searchingZipcode: false,
      filterOptions: [],

      openDuplicatesDialog: false,
      duplicates: [],
      noteInfo,
      haveChanged: {}
    };
  },
  computed: {
    customerInfoContentClass() {
      if (this.$q.screen.gt.sm) return 'row q-gutter-x-sm';
      return '';
    }
  },
  methods: {
    handleChangeInput(value) {
      const { name, model } = value;
      this[name] = model;
      this.$emit('input', {
        ...this.value,
        [name]: model
      });
      if (this.validation[name]) {
        this.delayTouch(this.validation[name], this.$options.touchMap);
      }
    },

    // the mask triggers the watch
    // this functiolns controls so that the dirty is not set in initial load
    handlePhoneChangeInput(value, ov, name) {
      if (ov !== undefined && ov !== `+1${value}`) {
            this.$emit('input', {
              ...this.value,
              [name]: value
            });
          if (this.validation[name]) {
            this.delayTouch(this.validation[name], this.$options.touchMap);
          }
      }
    }
  },
    watch: {
      'value.phone': function (value, ov) {
        this.handlePhoneChangeInput(value, ov, 'phone');
      },
      'value.phone2': function (value, ov) {
        this.handlePhoneChangeInput(value, ov, 'phone2');
      }
  }
};
</script>
